import React from 'react';
import { Progress } from 'antd';

interface ProgressCircleProps {
  percentage: number;
  status?: 'normal' | 'active' | 'success' | 'exception';
}

export default function ProgressCircle(props: ProgressCircleProps) {
  return (
    <Progress
      type="circle"
      strokeWidth={12}
      percent={props.percentage}
      status={props.status}
      width={50}
    />
  );
}
